import { api } from '../lib/api'

export type CrFile = {
  readonly id: number
  readonly url: string
  readonly image_url: string
  readonly name: string | null
  readonly created_at: string
  readonly modifiable: boolean
}

export type CrFilesIndex = {
  readonly patient: { readonly id: string; readonly name: string | null }
  readonly clinical_record_id: string
  readonly health_center_id: number
  readonly back_path: string
  readonly cr_files: readonly CrFile[]
}

/** The upload response is CarrierWave's own serialization, as the legacy Dropzone handler consumed it. */
export type UploadedCrFile = {
  readonly id: number
  readonly created_at: string
  readonly file: { readonly url: string; readonly image: { readonly url: string } }
}

function crFilesPath(healthCenterId: number, patientId: string, clinicalRecordId: string): string {
  return `/health_centers/${healthCenterId}/patients/${patientId}/clinical_records/${clinicalRecordId}/show/cr_files`
}

export function fetchCrFiles(healthCenterId: number, patientId: string, clinicalRecordId: string): Promise<CrFilesIndex> {
  return api.get<CrFilesIndex>(`${crFilesPath(healthCenterId, patientId, clinicalRecordId)}.json`)
}

export function uploadCrFile(
  healthCenterId: number,
  patientId: string,
  clinicalRecordId: string,
  file: File,
): Promise<UploadedCrFile> {
  const body = new FormData()
  body.append('file', file)
  body.append('clinical_record_id', clinicalRecordId)
  return api.post<UploadedCrFile>(`${crFilesPath(healthCenterId, patientId, clinicalRecordId)}.json`, body)
}

export function deleteCrFiles(healthCenterId: number, clinicalRecordId: string, ids: readonly number[]): Promise<void> {
  return api.delete<void>('/cr_files', { health_center_id: healthCenterId, clinical_record_id: clinicalRecordId, cr_files: ids })
}
